@if (account) {
  <div class="form-content">
    <div class="row">
      <app-input-text [formData]="usernameConfig" />

      <app-input-text [formData]="changeFullName" />
    </div>

    <div class="row">
      <app-input-text [formData]="changeEmail" />

      <app-input-select [formData]="languageSelect" />
    </div>

    @if (!isCurrentAccount) {
      <div class="row">
        <app-input-select [formData]="roleSelect" />

        <app-input-select-button [formData]="accountStatusConfig" />
      </div>
    }

    <hr class="break-line">
    @if (isCurrentAccount) {
      <div class="row">
        <app-input-text [formData]="currentPassword" />
      </div>
    }
    <div class="row">
      <app-input-text [formData]="changePassword" />
      <app-input-text [formData]="changePasswordRepeat" />
    </div>
  </div>

  <app-input-submit [formData]="submitConfig"
                    (click)="doUpdateUser()"
  />
}
